import { Icons } from '@cast/design-system';

import {
  ChartToggleOption,
  ChartType,
  ChartTypeToggleOptions,
} from 'types/charts';

export const chartToggleOption = {
  line: {
    value: ChartType.LINE,
    icon: <Icons.ChartLine />,
  },
  area: { value: ChartType.AREA, icon: <Icons.ChartLine /> },
  bar: { value: ChartType.BAR, icon: <Icons.ChartBar /> },
} satisfies Record<string, ChartToggleOption>;

export const chartTypeToggleOptions: ChartTypeToggleOptions = [
  chartToggleOption.line,
  chartToggleOption.area,
  chartToggleOption.bar,
];
